<template>
  <v-app>
    <nav-bar></nav-bar>

    <v-main>
      <router-view/>
    </v-main>

    <footer-bar></footer-bar>
  </v-app>
</template>

<script>

import NavBar from "@/components/NavBar";
import FooterBar from "@/components/FooterBar";
export default {
  name: 'App',
  components: {
    FooterBar,
    NavBar
  },
  data: () => ({
    //
  }),
  mounted() {

    let darkmode = false;
    if (localStorage.getItem('DarkMode') === 'true') {
      darkmode = true;
    } else {
      darkmode = false;
    }
    this.$vuetify.theme.dark = darkmode;
  }
};
</script>
<style>

/*main {*/
/*  background: rgb(71,160,255);*/
/*  background: linear-gradient(180deg, rgba(71,160,255,1) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 100%);*/
/*}*/

</style>